export default __webpack_public_path__ + "static/media/2638347_auto_board_car_dash_limit_icon.2e60de31.svg";